import { render, staticRenderFns } from "./WarrantyDtg.vue?vue&type=template&id=5ba108a9&"
import script from "./WarrantyDtg.vue?vue&type=script&lang=js&"
export * from "./WarrantyDtg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports